import { Routes, Route, Navigate } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import MainLayout from '../../../layouts/MainLayout';
import { ProtectedRoute } from '@/components/ccms-components/auth/components/ProtectedRoute';
import { Loader, Center } from '@/components/ui';

// Eager load dashboard for instant access
import QrCodesDashboard from './dashboard';

// Lazy load all other pages
const QrCodesListPage = lazy(() => import('./list'));
const MyCodesPage = lazy(() => import('./my-codes'));
const CreateQrCodePage = lazy(() => import('./create'));
const EditQrCodePage = lazy(() => import('./edit'));
const QrCodeDetailPage = lazy(() => import('./view/detail'));

// Admin pages
const AdminLookupsPage = lazy(() => import('./admin/lookups'));
const AdminFramesPage = lazy(() => import('./admin/frames'));
const AdminAssetsPage = lazy(() => import('./admin/assets'));
const AdminSettingsPage = lazy(() => import('./admin/settings'));

const LoadingFallback = () => (
  <Center h={400}>
    <Loader size="lg" />
  </Center>
);

/**
 * QR Code Management Routes
 * Complete routing configuration for the QR Codes domain
 */
export default function QrCodesRoutes() {
  return (
    <MainLayout domainKey="qr-codes">
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          {/* Dashboard - Default route */}
          <Route path="/" element={<QrCodesDashboard />} />

          {/* User Pages */}
          <Route path="/list" element={<QrCodesListPage />} />
          <Route path="/my-codes" element={<MyCodesPage />} />
          <Route path="/create" element={<CreateQrCodePage />} />
          <Route path="/edit/:id" element={<EditQrCodePage />} />

          {/* QR Code Detail View */}
          <Route path="/view/:id" element={<QrCodeDetailPage />} />

          {/* Admin Routes - Protected */}
          <Route
            path="/admin/lookups/*"
            element={
              <ProtectedRoute requiredRoles={['Admin']}>
                <AdminLookupsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/frames"
            element={
              <ProtectedRoute requiredRoles={['Admin']}>
                <AdminFramesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/assets"
            element={
              <ProtectedRoute requiredRoles={['Admin']}>
                <AdminAssetsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/settings"
            element={
              <ProtectedRoute requiredRoles={['Admin']}>
                <AdminSettingsPage />
              </ProtectedRoute>
            }
          />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/app/qr-codes" replace />} />
        </Routes>
      </Suspense>
    </MainLayout>
  );
}
